module.exports = __webpack_public_path__ + "static/media/popover_count.8a37926f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/popover_count.png
// module id = 1845
// module chunks = 0 1